import { Empty, Flex } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

import useTaskPrepareForDate from '../hooks/useTaskPrepareForDate';
import { RootState } from '../store';
import { ItemTaskType } from '../types';
import CalendarAgendaDay from './calendarAgendaDay';
import CalendarAgendaFilter from './calendarAgendaFilter';
import CalendarContainer from './calendarContainer';

const CalendarAgenda = () => {
    const filteredTasks = useSelector<RootState, ItemTaskType[]>((state) => state.calendar.filteredTasks);
    const dataDayList = useTaskPrepareForDate();

    return (
        <CalendarContainer>
            <CalendarAgendaFilter />
            <Flex justify={'start'} vertical>
                {filteredTasks.length ? (
                    Object.keys(dataDayList).map((date) => (
                        <CalendarAgendaDay
                            key={date}
                            agendaDate={date}
                            taskList={dataDayList[date].taskList}
                            itemList={dataDayList[date].itemList}
                        />
                    ))
                ) : (
                    <div style={{ paddingTop: 20 }}>
                        <Empty description={'No data to display'} />
                    </div>
                )}
            </Flex>
        </CalendarContainer>
    );
};

export default CalendarAgenda;
